import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestRefereeTeam',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId:this.$route.params.contestId,
            judgeList: null,
            isLoading:false
        }
    },
    created() {
        this.getAllJudge()
    },
    methods: {
        async getAllJudge() {
            try {
                this.judgeList = await contestApi.getAllJudge(this.contestId)
                this.isLoading = false
            } catch (error) {
                this.isLoading = false
                this.$toast.fail(error.message)
            }
        }
    }
}
